/** Six small marks in a row: the evidence chain of one figure, at a glance (`chain.ts`).
 *
 * Decorative beside the text that already says *Complete* or *Breaks at...*; it carries its own
 * accessible name (`role="img"`) so a screen reader hears the same sentence the tooltip shows. A link
 * is told apart by fill, shape and position - met is solid, broken is a cross, not checked is hollow -
 * never colour alone.
 */

import { Check, X } from "@phosphor-icons/react";

import { chainOf, chainSentence } from "./chain";
import styles from "./ChainDots.module.css";

export function ChainDots({
  figure,
}: {
  figure: { receipt_is_complete: boolean; evidence_broken_at?: string | null };
}) {
  const links = chainOf(figure);
  const sentence = chainSentence(links);
  return (
    <span className={styles.dots} role="img" aria-label={sentence} title={sentence} data-testid="chain-dots">
      {links.map((link) => (
        <span key={link.key} aria-hidden="true" className={`${styles.dot} ${styles[link.status]}`} data-link={link.key} data-status={link.status}>
          {link.status === "met" ? <Check size={8} weight="bold" aria-hidden="true" /> : null}
          {link.status === "broken" ? <X size={8} weight="bold" aria-hidden="true" /> : null}
        </span>
      ))}
    </span>
  );
}
